import React from 'react';
import Sidebar from 'layouts/App/AppContainers/Sidebar/Sidebar';
import TopBar from 'layouts/App/AppContainers/TopBar/TopBar';
import MainContainer from './AppContainers/MainContainer/MainContainer';
import './AppLayout.scss';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';
import {Toaster} from 'react-hot-toast';
import {useMediaQuery, useTheme} from '@mui/material';

const AppLayout = (props) => {

  const [toggled, setToggled] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(true);

  const handleToggle = (value) => {
    setToggled(value);
    setCollapsed(!value);
  };

  const useWidth = () => {
    const theme = useTheme();
    const keys = [...theme.breakpoints.keys].reverse();
    return (
      keys.reduce((output, key) => {
        const matches = useMediaQuery(theme.breakpoints.up(key));
        return !output && matches ? key : output;
      }, null) || 'xs'
    );
  };

  return (
    <>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            zIndex: '9999',
            padding: '16px',
            backgroundColor: 'var(--kreatize-turquoise)',
            maxWidth: '800px',
          },
        }}
        containerStyle={{
          inset: 0,
          id: 'toaster',
        }}
      />
      <TopBar {...props} handleSidebarToggle={handleToggle} sidebarToggled={toggled} />

      <div className={`app ${toggled ? 'toggled' : ''} ${collapsed ? 'collapsed' : ''}`}>
        <Sidebar {...props} collapsed={collapsed} toggled={toggled} handleSidebarToggle={handleToggle} handleSidebarCollapsed={setCollapsed} />
        <ErrorBoundary {...props}>
          <MainContainer {...props} style={{marginLeft: ['xs', 'sm'].includes(useWidth()) ? 0 : 80}} />
        </ErrorBoundary>
      </div>
    </>
  );
};

export default AppLayout;
